// import React from 'react'
// import {Link} from 'react-router-dom'
// import {
//     MDBBtn,
//     MDBContainer,
//     MDBRow,
//     MDBCol,
//     MDBCard,
//     MDBCardBody,
//     MDBInput,
    
//   }
//   from 'mdb-react-ui-kit';

// const AdminSignup = () => {
//   return (
//     <div>
//         <MDBContainer fluid>

//             <MDBRow className='d-flex justify-content-center align-items-center h-100'>
//             <MDBCol col='12'>

//                 <MDBCard className='bg-dark text-white mx-auto mt-4' style={{borderRadius: '1rem', maxWidth: '900px'}}>
//                 <MDBCardBody className='p-5 d-flex flex-column align-items-center mx-auto w-100'>

//                     <h2 className="fw-bold mb-2 text-uppercase">Sign-Up</h2>
//                     <p className="text-white-50 mb-5">Please enter information!</p>

                    
//                         <MDBInput wrapperClass='mb-4 me-5 mx-auto w-100' labelClass='text-white'  placeholder='Full Name' id='formControlLg' type='text' size="lg"/>
                         
//                     <MDBInput wrapperClass='mb-4 mx-5 w-100' labelClass='text-white'  placeholder='Email' id='formControlLg' type='email' size="lg"/>
//                     <MDBInput wrapperClass='mb-4 mx-5 w-100' labelClass='text-white'   placeholder='Mobile Number' id='formControlLg' type='number' size="lg"/>
//                     <MDBInput wrapperClass='mb-4 mx-5 w-100' labelClass='text-white'  placeholder='Password' id='formControlLg' type='password' size="lg"/>
//                     <MDBInput wrapperClass='mb-4 mx-5 w-100' labelClass='text-white'  placeholder='Confirm Password' id='formControlLg' type='password' size="lg"/>
//                     <p className="small mb-3 pb-lg-2"><span><Link to='/forgot-password'><strong>Forgot password?</strong></Link></span></p>
//                     <MDBBtn outline className='mx-2 px-5' size='lg'>
//                      <span className='text-white'>Sign-Up</span>
//                     </MDBBtn>
//                     <span>Have an account?</span><Link to='/admin-login-page'><strong>Login</strong></Link>
//                 </MDBCardBody>
//                 </MDBCard>

//             </MDBCol>
//             </MDBRow>
//         </MDBContainer>
//     </div>
//   )
// }

// export default AdminSignup


import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import logo from '../img/logo.png';

import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardBody,
  MDBInput,
  MDBBtn,
} from 'mdb-react-ui-kit';

const AdminSignup = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  const [district, setDistrict] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  
  const [districts, setDistricts] = useState([]);

  const navigate = useNavigate();

  // ✅ Fetch districts on load
  useEffect(() => {
    const fetchDistricts = async () => {
      try {
        const res = await axios.get("https://lionsdirectoryapi.emedha.in/auth/api/api/districts");
        setDistricts(res.data || []);
      } catch (error) {
        console.error("Error fetching districts:", error);
      }
    };
    fetchDistricts();
  }, []);
  
  const handleSignup = async () => {
    if (!name || !email || !mobile || !district || !password || !confirmPassword) {
      return alert('All fields are required.');
    }

    if (password !== confirmPassword) {
      return alert('Passwords do not match.');
    }

    try {
      const response = await axios.post('https://lionsdirectoryapi.emedha.in/auth/api/api/dist-signup', {
        name,
        email,
        mobile,
        district,
        password,
      });

      alert(response.data.message);
      // Optionally redirect to login:

       navigate('/verify-otp', { state: { email } });  
    } catch (error) {
      console.error('Signup Error:', error);
      alert(error.response?.data?.message || 'Signup failed. Please try again.');
    }
  };

  return (
    <div>
      <br /><br /><br /><br />
      <MDBContainer fluid>
        <MDBRow className="d-flex justify-content-center align-items-center h-100">
          <MDBCol col="12">
            <MDBCard
              className="bg-warning text-white my-2 mx-auto"
              style={{ borderRadius: '1rem', maxWidth: '480px' }}
            >
              <MDBCardBody className="p-5 d-flex flex-column align-items-center mx-auto w-100">
                <h2 className="fw-bold mb-4 text-uppercase">
                  <img
                    src={logo}
                    height="100px"
                    width="100px"
                    className="logo1"
                    alt="Logo"
                  />
                </h2>

                <MDBInput
                  wrapperClass="mb-3 mx-5 w-100"
                  placeholder="Name"
                  type="text"
                  size="lg"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                <MDBInput
                  wrapperClass="mb-3 mx-5 w-100"
                  placeholder="Email"
                  type="email"
                  size="lg"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <MDBInput
                  wrapperClass="mb-3 mx-5 w-100"
                  placeholder="Mobile Number"
                  type="number"
                  size="lg"
                  value={mobile}
                  onChange={(e) => setMobile(e.target.value)}
                />

                {/* ✅ District Dropdown */}
               <select
                  className="form-select mb-3 mx-5 w-100"
                  value={district}
                  onChange={(e) => setDistrict(e.target.value)}
                >
                  <option value="">Select District</option>
                   {districts.map((d) => (
    <option key={d.id} value={d.name}>
      {d.name}
    </option>
  ))}
                </select>

                <MDBInput
                  wrapperClass="mb-3 mx-5 w-100"
                  placeholder="Password"
                  type="password"
                  size="lg"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <MDBInput
                  wrapperClass="mb-3 mx-5 w-100"
                  placeholder="Confirm Password"
                  type="password"
                  size="lg"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
           <button className="btn btn-danger mx-5 px-5" 
                  onClick={handleSignup}
                >
                  <span className="text-white">Sign-Up</span>
                </button>

                <p className="mt-3 text-light">
                  Already have an account?{' '}
                  <Link to="/">
                    <strong style={{ color: 'navy' }}>Log in here</strong>
                  </Link>
                </p>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
    </div>
  );
};

export default AdminSignup;
